<template>
  <div class="m-form__section m-form__section--third">
    <div class="m-portlet__body">
      <div
        class="form-group m-form__group row"
        v-for="(info, key) in dataFields"
        :key="'data_'+key"
        v-if="renderRow(key, dataFields[key])"
      >
        <div class="col-lg-6" v-if="dataFields[key] === 'string'">
          <label class>{{ inputLabel(key) | capitalize }}{{ isRequiredField(key) }} :</label>
          <input type="text" class="form-control m-input" v-model="form[key]" />
        </div>
        <div class="col-lg-10" v-else-if="dataFields[key] === 'longtext'">
          <label class>{{ inputLabel(key) | capitalize }}{{ isRequiredField(key) }} :</label>
          <textarea rows="10" class="form-control m-input" v-model="form[key]"></textarea>
        </div>
      </div>
    </div>
    <div class="m-form__actions m-form__actions">
      <div class="row">
        <div :class="formType ? 'col-lg-2' : 'col-lg-1'">
          <button
            type="button"
            data-dismiss="modal"
            class="btn btn-secondary"
            @click="closeAction(true)"
          >{{ labels.cancel }}</button>
        </div>
        <div class="col-lg-2">
          <button
            type="button"
            class="btn btn-primary"
            @click="saveForm"
            :disabled="inProgress"
          >{{ labels.save }}</button>
        </div>
        <div
          :class="formType ? 'col-lg-8' : 'col-lg-9'"
          style="text-align:right;"
        >{{ labels.required_fields_info }}</div>
      </div>
    </div>
  </div>
</template>

<script>
// Dependencies
import { mapState, mapActions } from 'vuex';

// Mixins
import axios from 'axios';
import SweetAlert from '../../assets/js/mixins';
import UpdateFirestore from '../../assets/js/mixins';

// JSON
import dataFields from '../../data/schemas/CRUD_data_structure.json';
import { firebase } from '../../assets/js/firebase';
import { CRUDCreate, CRUDUpdate } from '../../assets/js/CRUDFirestore';

const timer = 2000;

export default {
  props: ['param', 'data', 'index', 'name', 'formType'],
  mixins: [SweetAlert, UpdateFirestore],
  data() {
    return {
      form: {},
      inProgress: false,
    };
  },
  computed: {
    ...mapState({
      labels: (store) => store.labels,
      roles: (store) => store.roles,
      crudData: (store) => store.crudData.cruds,
      countries: (store) => store.countries,
      newCRUD: (store) => store.crudData.newCRUD,
      formData: (state) => state.products.formData,
    }),
    dataFields() {
      return dataFields[this.param];
    },
  },
  methods: {
    ...mapActions([
      'toggleCRUDMode',
      'products/setFormModalData',
      'products/productSegmentAction',
      'products/updateSelectedSegments',
      'setNewCRUD',
      'setUserInfo',
    ]),
    inputLabel(key) {
      if (
        this.dataFields.hasOwnProperty('custom_titles')
        && this.dataFields.custom_titles[key]
      ) {
        return this.labels[this.dataFields.custom_titles[key]];
      }
      return this.labels[key];
    },
    // Checks is a resource property is editable (set in data structure.json)
    renderRow(key, value) {
      return this.dataFields.columns.indexOf(key) !== -1;
    },
    // Check is resource property is required (set in data structure.json)
    isRequiredField(key) {
      const required = this.dataFields.required.filter((field) => field === key);
      return required.length ? '*' : null;
    },
    closeAction(close) {
      // Close this form
      this.toggleCRUDMode(null);
      // Close product form modal
      this['products/setFormModalData'](null);
      $('#formModalClose').trigger('click');

      if (close && close.errorMessage) {
        this.sweetAlert('warning', close.errorMessage, timer);
      } else {
        // Trigger sweetAlert to notify save success
        this.sweetAlert('success', this.labels.saved, timer);
      }
    },
    saveForm() {
      this.inProgress = true;
      if (!this.data || this.index === 'new') {
        // Send POST request
        this.createItem();
      } else {
        this.updateItem();
      }
    },
    async createItem() {
      const result = await CRUDCreate(this.param, this.form);

      // Success actions
      this.inProgress = false;
      this.closeAction(result);
      // Update firestore
      // 1. Add new item to table top

      if (!result || !result.errorMessage) {
        this.setNewCRUD({ name: this.param, item: this.form });
        this.updateFirestore(this.param);
      }
    },
    async updateItem() {
      const result = await CRUDUpdate(this.param, this.data.id, this.form);
      if (!result || !result.errorMessage) {
        this.updateFirestore(this.param);
      }
      this.closeAction(result);
    },
    buildDataFields() {
      this.form = {};

      this.dataFields.columns.forEach((columnProperty) => {
        if (this.data && this.data.hasOwnProperty(columnProperty)) {
          this.form[columnProperty] = this.data[columnProperty];
        } else if (this.name && columnProperty === 'name') {
          // If there is a name value we pre-fill the name field with this value (used for product form modal)
          this.form.name = this.name;
        } else {
          Array.isArray(this.dataFields[columnProperty])
            ? (this.form[columnProperty] = [])
            : (this.form[columnProperty] = '');
        }
      });
    },
  },
  created() {
    // Sync with existing data values on from the fields that are editable (set in structure.json)
    this.buildDataFields();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/CRUDs/SimpleForm.vue